import Vue from 'vue';
import numeral from 'numeral';
import 'numeral/locales';

numeral.locale('fr');

Vue.filter('distance', (value) => {
  if (!value) return '0 km';
  return `${numeral(value).format('0,0')} km`;
});

Vue.filter('volume', (value) => {
  if (!value) return '0 l';
  return `${numeral(value).format('0,0.00')} l`;
});

Vue.filter('price', (value) => {
  if (!value) return '0 eur';
  return `${numeral(value).format('0,0.00')} eur`;
});

Vue.filter('consumption', (value) => {
  if (!value) return '0 l/100km';
  return `${numeral(value).format('0,0.00')} l/100km`;
});

Vue.filter('pricePerKm', (value) => {
  if (!value) return '0 eur/km';
  return `${numeral(value).format('0,0.00')} eur/km`;
});
